import envVar from '../../config/envVars';
import httpGet from '../httpClient/httpGet';
import authenticationUtils from '../../utils/authenticationUtils';

const getQueryParams = (
  page: number,
  perPage: number,
  school?: string,
  academicYear?: string
): string => {
  const params = new URLSearchParams();
  params.append('page', String(page));
  params.append('perPage', String(perPage));
  if (school && school !== 'All') params.append('school', school);
  if (academicYear && academicYear !== 'All')
    params.append('session', academicYear);
  return params.toString();
};

const getCashOutflowReport = async (
  page: number,
  perPage: number,
  school?: string,
  academicYear?: string
) => {
  const queryParams = getQueryParams(page, perPage, school, academicYear);
  return httpGet(
    `${envVar.REACT_APP_PAYMENTS_API_BASE_URL}/reports/cash-flow?${queryParams}`,
    {
      headers: {
        Authorization: `Bearer ${authenticationUtils.getEasypayToken?.() || ''}`
      }
    }
  );
};

export { getCashOutflowReport };
